// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__M12nn","createBtn":"styles_createBtn__ndzH8","studyBtn":"styles_studyBtn__2sZqQ"};